export default __webpack_public_path__ + "static/media/active_reject-icon.cf81b003.svg";